import React, { useState, useEffect } from 'react';
import '../../css/ConnectionStatus.css';

const ConnectionStatus = ( { gameStateManager } ) =>
{
  const [ connectionStatus, setConnectionStatus ] = useState( {
    isReconnecting: false,
    reconnectAttempts: 0
  } );

  useEffect( () =>
  {
    if( !gameStateManager ) return;

    const handleConnectionStatusChange = ( status ) =>
    {
      setConnectionStatus( status );
    };

    // Register for connection status updates
    gameStateManager.addOnConnectionStatusChangeCallback( handleConnectionStatusChange );

    // Cleanup on unmount
    return () =>
    {
      gameStateManager.removeOnConnectionStatusChangeCallback( handleConnectionStatusChange );
    };
  }, [ gameStateManager ] );

  const handleManualRefresh = () =>
  {
    if( gameStateManager )
    {
      gameStateManager.manualRefresh();
    }
  };

  // Show component if reconnecting OR if max attempts reached
  const maxAttempts = gameStateManager.maxReconnectAttempts;
  const hasReachedMaxAttempts = connectionStatus.reconnectAttempts > maxAttempts;

  if( !connectionStatus.isReconnecting )
  {
    return null; // Don't show anything when not reconnecting
  }

  return (
    <div className="connection-status-bar">
      <div className="connection-status-content">
        <div className="connection-status-text">
          <span className="connection-status-icon">⚠️</span>
          { hasReachedMaxAttempts ? (
            <>Connection Lost. Please refresh page.</>
          ) : (
            <>
              Connection Lost. Trying to reconnect...
              { connectionStatus.reconnectAttempts > 0 && (
                <span className="reconnect-attempts">
                  (Attempt { connectionStatus.reconnectAttempts }/{ maxAttempts })
                </span>
              ) }
            </>
          ) }
        </div>
      </div>
    </div>
  );
};

export default ConnectionStatus;
